<template>
  <div>
    <v-app-bar height="100" app elevate-on-scroll :clipped-left="$vuetify.breakpoint.lgAndUp">
      <v-app-bar-nav-icon v-if="isAuthenticated && isConfigured && isSubscriptionActive" @click.stop="drawerSet(!drawer)" />
      <v-avatar
        class="mx-3"
        :color="$vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-5'"
        size="80"
      >
        <v-img contain max-height="80%" :src="getLogo()"></v-img>
      </v-avatar>
      <v-toolbar-title class="font-weight-black headline hidden-sm-and-down">
        {{appName.toUpperCase()}}
        <span class="pt-0 mt-0 font-weight-light text-h6 grey--text">Beta</span>
        <br />
        <span class="font-weight-light text-h6" v-if="selectedBot && selectedBot.first_name">{{selectedBot.first_name}}</span>
      </v-toolbar-title>

      <v-spacer />
      <v-toolbar-items class="hidden-sm-and-down" v-if="!isAuthenticated">
        <v-btn text x-large v-for="item in mainMenu" :key="item.title" :to="{ name: item.link }">
          <span>{{item.title}}</span>
        </v-btn>
      </v-toolbar-items>
      <v-spacer />

      <v-menu bottom left v-if="$vuetify.breakpoint.mdAndDown">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, i) in mainMenu" :key="i" :to="{ name: item.link }">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'login' }" v-if="!isAuthenticated">
            <v-icon class="mr-2">mdi-key</v-icon>Login
          </v-list-item>
          <v-list-item @click="doLogout" v-if="isAuthenticated">
            <v-icon class="mr-2">mdi-exit-to-app</v-icon>Logout
          </v-list-item>
        </v-list>
      </v-menu>

      <!--<v-badge
        left
        overlap
        class="hidden-sm-and-down mx-2"
        color="info"
        content="2"
        v-if="isAuthenticated"
      >
        <v-btn icon title="Notifications">
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </v-badge>-->

      <v-btn
        class="hidden-sm-and-down mx-2 pulse-icon"
        color="primary"
        icon
        :to="{ name: 'account' }"
        v-if="needsRevision"
        :title="user.account.subscription.revise_type === 'upgrade' ? 'Needs Upgrade':'Can Downgrade'"
      >
        <v-icon
          class
        >{{user.account.subscription.revise_type === 'upgrade' ? 'mdi-cart-arrow-up':'mdi-cart-arrow-down'}}</v-icon>
      </v-btn>

      <v-btn
        class="hidden-sm-and-down mx-2"
        icon
        :to="{ name: 'dashboard' }"
        v-if="isAuthenticated"
        title="Dashboard"
      >
        <v-icon>mdi-view-dashboard</v-icon>
      </v-btn>

      <v-menu
        bottom
        offset-y
        v-model="showAccountMenu"
        v-if="isAuthenticated"
        origin="center center"
        transition="scale-transition"
        z-index="1000"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="mx-2" title="Account">
            <v-icon class="hidden-sm-and-down">mdi-account-circle</v-icon>
            <v-icon class="hidden-md-and-up">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            class="hidden-md-and-up"
            v-for="item in mainMenu"
            :key="item.title"
            :to="{ name: item.link }"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-subheader>Account</v-subheader>

          <v-list-item
            v-for="item in configMenu"
            :key="item.title"
            :to="item.link ? { name: item.link } : null"
            @click="item.click ? item.click() : () => {}"
            v-show="((item.link !== 'bot') || (item.link === 'bot' && user.account_id))"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        class="hidden-sm-and-down mx-2 mr-0"
        icon
        :to="{ name: 'login' }"
        v-if="!isAuthenticated"
        title="Log in"
      >
        <v-icon>mdi-key</v-icon>
      </v-btn>

      <v-btn
        class="hidden-sm-and-down mx-2 mr-0"
        icon
        @click="doLogout"
        v-if="isAuthenticated"
        title="Log out"
      >
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>
    <slot></slot>
  </div>
</template>

<script>
import { apiClient } from "@/api";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    prominent: true,
    mainMenu: [
      { title: "Home", icon: "mdi-account", link: "home" },
      { title: "Features", icon: "mdi-account-plus", link: "features" },
      { title: "Pricing", icon: "mdi-account-plus", link: "pricing" },
      { title: "Sign Up", icon: "mdi-account-plus", link: "signup" },
    ],
    configMenu: [],
  }),
  computed: {
    ...mapGetters("apiAuth", ["isAuthenticated", "user"]),
    ...mapGetters("app", [
      "drawer",
      "accountMenu",
      "profileDialog",
      "selectedBot",
    ]),
    ...mapState("app", ["appName"]),
    isConfigured() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        this.user.account.subscription.active &&
        (this.user.account.subscription.paypal_subscription || this.user.account.subscription.free) &&
        this.user.account.bots &&
        this.user.account.bots.length
      );
    },
    isSubscriptionActive() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        this.user.account.subscription.active &&
        (this.user.account.subscription.paypal_subscription || this.user.account.subscription.free)
      );
    },
    needsRevision() {
      return false; /*(
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        this.user.account.subscription.needs_revision
      );*/
    },
    showAccountMenu: {
      get() {
        return this.accountMenu;
      },
      set(val) {
        this.accountMenuSet(val);
      },
    },
  },
  methods: {
    ...mapActions("apiAuth", { apiLogout: "logout" }),
    ...mapActions("botAuth", { botLogout: "logout" }),
    ...mapActions("app", [
      "drawerSet",
      "accountMenuSet",
      "profileDialogSet",
      "showMessage"
    ]),
    async doLogout() {
      try {
        await this.$router.push({ name: "login" });
        await this.apiLogout();
        await this.botLogout();
        this.showMessage({
          text: "You've been logged out!",
          colour: "success",
        });
        apiClient.emit("authentication", { event: "logged-out" });
      } catch (error) {
        this.showMessage({ text: error.message, colour: "error" });
      }
    },
    getLogo() {
      var images = require.context("@/assets/", false, /\.png$/);
      return images(
        this.$vuetify.theme.dark
          ? "./GroupBot-Logo-Dark.png"
          : "./GroupBot-Logo-Light.png"
      );
    },
  },
  created() {
    this.configMenu = [
      {
        title: "Profile",
        icon: "mdi-clipboard-account",
        click: () => this.profileDialogSet(true),
      },
      { title: "Account", icon: "mdi-account", link: "account" },
      { title: "Users", icon: "mdi-account-multiple", link: "users" },
      {
        title: "Bot",
        icon: "mdi-robot",
        link: "bot",
      },
    ];
  },
  watch: {},
};
</script>

<style lang="scss">
.tooltip-wrapper {
  position: relative;
}

.v-btn {
  &.v-btn--text {
    &:before {
      background-color: transparent;
    }
  }
}

.pulse-icon {
  -webkit-animation: pulse 2s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse 2s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse 2s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse 2s infinite cubic-bezier(0.66, 0, 0, 1);

  &:hover {
    -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    animation: none;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  50% {
    transform: scale(1.2);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
</style>